<div
  class="custom-md-view-wrapper"
  [ngClass]="{'no-filter-ui': !filterableState() || isSystemView()}">
  <app-node-path
    *ngIf="!hideNodePath"
    class="custom-md-view__node-path"
    [nodePath]="nodePath$ | async"></app-node-path>
  <q9-grid
    #grid="q9Grid"
    [useColourStickers]="true"
    [displayHorizontalContextMenu]="!disableContextMenu"
    [columns]="columns$ | async"
    [selectBy]="idField"
    [menuItems]="menuItems"
    [templates]="supplementalGridTemplates"
    [useManualFilter]="true"
    [useManualSort]="true"
    [sortable]="gridSortable()"
    [filterable]="gridFilterable()"
    [enableMultiSelect]="isMultipleMode"
    (stateChanged)="onGridStateChanged($event)"></q9-grid>
</div>
